import type { AlertProps } from '@design/objects/alert/contract'

export default function (element: string | HTMLElement, config?: Partial<AlertProps>): void {
  let el: HTMLElement | string | null = element

  if (typeof element === 'string') {
    el = document.querySelector<HTMLElement>(element)
  }

  if (!el || typeof el === 'string') {
    return
  }

  const buttonEl = el.querySelector<HTMLButtonElement>('.o-alert__close')
  if (buttonEl && el) {
    buttonEl.addEventListener('click', () => {
      ;(el as HTMLElement).setAttribute('data-visible', 'false')

      config?.onClose?.()
    })
  }
}
